import TrendingBattles from "../components/TrendingBattles";
import "../App.css";

export default function TrendingPage() {
  return (
    <section className="arena-bg">
      <div className="page-heading">
        <h2 className="page-title">Trending Battles</h2>
        <p className="page-sub">The most-fought matchups right now</p>
      </div>
      <TrendingBattles />
    </section>
  );
}
